module.exports = __webpack_public_path__ + "static/particle-bottom-right-a33c6aca44edb7d79cd3b83380e078b0.png";